import { h } from '@stencil/core';
import { FluidAlignment, FluidPopoverConfig } from '@lmig/fluid-core';

export const PopoverTooltip = (props: {
  popoverContent: string;
  displayValue: any;
  popoverConfig: FluidPopoverConfig;
  textAlign?: FluidAlignment;
}) => {
  const { popoverContent, displayValue, popoverConfig, textAlign } = props;

  return (
    <fluid-popover config={popoverConfig}>
      <span
        slot='trigger'
        innerHTML={displayValue}
        class={{
          'popover-tooltip-trigger': true,
          [`align-${textAlign ?? 'left'}`]: true,
        }}
      />
      <div
        slot='content'
        class='popover-tooltip-content'
        innerHTML={popoverContent}
      />
    </fluid-popover>
  );
};
